/**
 * WorkspaceDetailsFields
 *
 * The "Define your workspace" inputs (Figma 9224:4435) — company logo upload
 * and workspace name — shared by the onboarding wizard's step 2 and the
 * "+ Add New Workspace" modal so both surfaces stay identical.  The workspace
 * name *is* the company name, so there is deliberately no separate company
 * field here.  Fully controlled: the owner holds the values and decides what
 * to do with the picked logo file (resize, validate, store).
 */
import React from 'react';

import { AvatarUpload, Input } from '@spark';

import { LOGO_ACCEPT } from '../utils/logoImage';

export default function WorkspaceDetailsFields({
    idPrefix = 'workspace-details',
    size = 'large',
    logo = null,
    onLogoFile,
    name = '',
    onNameChange,
    nameError = '',
    nameHelperText = '',
    disabled = false,
    logoDisabled = disabled,
}) {
    const helperText = nameError || nameHelperText;
    return (
        <div className="onboarding-fields">
            <AvatarUpload
                label="Add Company Logo"
                emptyVariant="dashed"
                src={logo || undefined}
                alt="Company logo"
                accept={LOGO_ACCEPT}
                disabled={logoDisabled}
                onFileSelected={(file) => onLogoFile?.(file)}
            />
            <Input
                id={`${idPrefix}-workspace-name`}
                size={size}
                label="Workspace Name"
                showAsterisk
                name="workspace"
                autoComplete="off"
                placeholder="Name of company workspace"
                value={name}
                maxLength={200}
                danger={Boolean(nameError)}
                showHelperText={Boolean(helperText)}
                helperText={helperText}
                disabled={disabled}
                onChange={(event) => onNameChange?.(event.target.value)}
            />
        </div>
    );
}
